import { render } from "./Videos.vue?vue&type=template&id=3970a000"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
script.render = render

export default script